<!--分单管理-计划工作台-->
<template>
  <ls-table-layout>
    <div class="table-page-search-wrapper" slot="search">
      <ls-search-form @search="onSearch" @reset="resetQuery" :formList="formList" ref="refSearchForm">
        <global-select
          ref="versionSelectRef"
          slot="version"
          :assembleLabel="false"
          :value.sync="queryParams.version"
          selectType="selectSearch"
          requestApi="/scp/scpMpsFdPlans/findVersionList"
          :selectItem="{ value: 'realValue', label: 'label' }"
          searchParam="version" />
        <global-select
          ref="weekPlanVersionRef"
          slot="weekPlanVersion"
          :assembleLabel="false"
          :value.sync="queryParams.weekPlanVersion"
          selectType="selectSearch"
          requestApi="/scp/scpMpsFdPlans/findWeekVersionList"
          :selectItem="{ value: 'realValue', label: 'label' }"
          searchParam="version" />
        <global-select
          slot="statusList"
          :value.sync="queryParams.status"
          :selectData="statusList"
          selectType="selectFilter"
          :selectItem="{ value: 'lookupCode', label: 'lookupValue' }"
        />
      </ls-search-form>
    </div>
    <div slot="btn">
      <a-space>
        <a-button :loading="loading" @click="onCreateMainPlan">新建主计划</a-button>
        <a-button :loading="loading" @click="onFirstRound">执行首轮分配</a-button>
<!--        <a-button :loading="loading" @click="onSecondRound">执行次轮分配</a-button>-->
        <a-button :loading="loading" @click="onMonthToWeek">月到周分配</a-button>
        <a-button
          :disabled="selectedRows.length<1||selectedRows[0].status!=='RUNNING'"
          :loading="loading"
          @click="onTerminate">
          强制终止
        </a-button>
        <create-main-plan ref="createMainPlanRef" @refresh="handleOk" />
      </a-space>
    </div>
    <template v-slot:table>
      <div class="page-header-content">
        <!-- 表格 -->
        <ls-api-table
          ref="dataTable"
          :columns="columns"
          :tableProps="tableProps"
          rowKey="id"
          :selectedRows.sync="selectedRows"
          :multi-select="false"
          @selectedRowChange="selectedRowChange"
          :scroll="{ fixScreen: true, x: 1600 }">
          <template slot="time" slot-scope="{ text }">
            <span>{{ text && $moment(text).format('YYYY-MM-DD HH:mm:ss') }}</span>
          </template>
          <template slot="date" slot-scope="{ text }">
            <span>{{ text && $moment(text).format('YYYY-MM-DD') }}</span>
          </template>
          <div slot="operation" slot-scope="text" class="operation-btn">
            <a-popconfirm
              v-if="['NEW', 'TERMINATED', 'CLOSE'].includes(text.record.status)"
              title="确定要删除吗？"
              ok-text="确定"
              cancel-text="取消"
              @confirm="handleDel(text.record)"
            >
              <a-button :loading="loading" type="link">删除</a-button>
            </a-popconfirm>
            <a-popconfirm
              v-if="text.record.status!=='CLOSE'"
              title="确定要关闭吗？"
              ok-text="确定"
              cancel-text="取消"
              @confirm="handleClose(text.record)"
            >
              <a-button :loading="loading" type="link">关闭</a-button>
            </a-popconfirm>
            <a-popconfirm
              v-if="text.record.status==='MONTH_TO_WEEK'"
              title="确定要发布吗？"
              ok-text="确定"
              cancel-text="取消"
              @confirm="handleRelease(text.record)"
            >
              <a-button :loading="loading" type="link">发布</a-button>
            </a-popconfirm>
          </div>
        </ls-api-table>
      </div>
    </template>
  </ls-table-layout>
</template>

<script>
import { generateLsTableResData } from '@/utils/util.js'
import cloneDeep from 'lodash.clonedeep'
import createMainPlan from '@/views/finished-goods-order/allocation-management/planning-workbench/components/create-main-plan.vue'
import {
  apiScpFindPlansFdPage,
  apiScpStartFirstAllocation,
  apiScpTerminatePlan,
  apiScpStartSecondAllocation,
  apiScpStartMonthToWeek,
  apiScpMpsFdPlansDelete,
  apiScpMpsFdPlansClose,
  apiScpMpsFdPublish
} from '@/api/finished-goods-order'
import cacheRequest from '@/mixins/cacheRequest'

export default {
  // eslint-disable-next-line
  name: 'Planning-workbench', // name要和rms配置菜单路由保存一致
  components: { createMainPlan },
  mixins: [cacheRequest],
  data() {
    return {
      // NEW新建、RUNNING运行中、FIRST_ALLOCATION首轮分配执行完成、SECOND_ALLOCATION次轮分配执行完成、TERMINATED已终止、COMPLETED已完成、MONTH_TO_WEEK月到周分配执行完成、CLOSE已关闭
      statusList: [],
      loading: false,
      selectedRowKeys: [],
      selectedRows: [],
      // 表格配置
      tableProps: {
        requestApi: generateLsTableResData(apiScpFindPlansFdPage, false),
        pageCurrent: true
      },
      // 查询参数
      queryParams: {
        version: undefined,
        status: undefined,
        weekPlanVersion: undefined
      },
      formList: [
        { label: '计划版本', decorator: ['version'], type: 'version' },
        { label: '状态', decorator: ['status'], type: 'statusList' },
        { label: '周版本计划', decorator: ['weekPlanVersion'], type: 'weekPlanVersion' }
      ],
      // 表格字段
      columns: [
        { title: '周版本计划', dataIndex: 'weekPlanVersion', align: 'center', width: 120 },
        { title: '计划版本', dataIndex: 'version', align: 'center', width: 120 },
        { title: '版本说明', dataIndex: 'description', align: 'center', width: 160, ellipsis: true },
        { title: '参数版本', dataIndex: 'optionVersion', align: 'center', width: 120 },
        { title: '产品属性', dataIndex: 'itemAttributeName', align: 'center', width: 120 },
        { title: '包含值', dataIndex: 'includeValuesName', align: 'center', width: 180, ellipsis: true },
        { title: '月度计划名称和版本', dataIndex: 'monthPlanVersionName', align: 'center', width: 180, ellipsis: true },
        { title: '状态', dataIndex: 'statusName', align: 'center', width: 110 },
        { title: '最后更新人', dataIndex: 'updateName', align: 'center', width: 100 },
        { title: '开始时间', dataIndex: 'dataStartDate', align: 'center', width: 150, scopedSlots: { customRender: 'time' } },
        { title: '最后更新日期', dataIndex: 'updateTime', align: 'center', width: 120, scopedSlots: { customRender: 'date' } },
        {
          title: '操作',
          width: 110,
          dataIndex: 'operation',
          align: 'center',
          scopedSlots: { customRender: 'operation' },
          stickyFixed: 'right'
        }
      ]
    }
  },
  created() {
    this.cacheLookupRequest('SCP_MPS_FD_PROCESS_STATUS', { lookupType: 'SCP_MPS_FD_PROCESS_STATUS', current: 1, pageSize: 999 }, 'statusList')
  },
  mounted() {
    this.loading = false;
    this.onSearch()
  },
  methods: {
    // 创建主计划
    onCreateMainPlan() {
      this.$refs.createMainPlanRef.show()
    },
    // 强制终止
    onTerminate() {
      this.confirmFun('是否强制终止该单据？', apiScpTerminatePlan, { version: this.selectedRows[0].version })
    },
    // 首轮分配
    onFirstRound() {
      if(this.selectedRows?.length < 1) {
        return this.$message.warning("请勾选单据进行操作")
      }
      if (this.selectedRows[0]?.status !== 'NEW') {
        return this.$message.warning("状态不符，无法执行")
      }
      this.confirmFun('是否执行首轮分配？', apiScpStartFirstAllocation, { version: this.selectedRows[0].version })
    },
    // 次轮分配
    onSecondRound() {
      if(this.selectedRows?.length < 1) {
        return this.$message.warning("请勾选单据进行操作")
      }
      if (this.selectedRows[0]?.status !== 'FIRST_ALLOCATION') {
        return this.$message.warning("状态不符，无法执行")
      }
      this.confirmFun('是否执行次轮分配？', apiScpStartSecondAllocation, { version: this.selectedRows[0].version })
    },
    // 月到周分配
    onMonthToWeek() {
      if(this.selectedRows?.length < 1) {
        return this.$message.warning("请勾选单据进行操作")
      }
      if (this.selectedRows[0]?.status !== 'FIRST_ALLOCATION') {
        return this.$message.warning("状态不符，无法执行")
      }
      this.confirmFun('是否执行月到周分配？', apiScpStartMonthToWeek, { version: this.selectedRows[0].version })
    },
    // 删除
    handleDel(data) {
      if (this.loading) { return false }
      this.pubRequest(apiScpMpsFdPlansDelete, { id: data.id })
    },
    // 关闭
    handleClose(data) {
      if (this.loading) { return false }
      this.pubRequest(apiScpMpsFdPlansClose, { version: data.version })
    },
    // 发布
    handleRelease(data) {
      if (this.loading) { return false }
      this.pubRequest(apiScpMpsFdPublish, { version: data.version })
    },
    // 通用确认请求
    confirmFun(tip, urlServe, params) {
      this.$confirm({
        title: '提示',
        content: tip,
        okText: '确认',
        cancelText: '取消',
        onOk: () => {
          this.pubRequest(urlServe, params)
        }
      })
    },
    // 公共请求
    pubRequest(urlServe, params) {
      this.loading = true;
      urlServe(params).then(response => {
        if (response?.code === 200) {
          this.$message.success(response?.msg || '操作成功')
          this.onSearch()
        }
      }).finally(() => {
        this.loading = false;
      })
    },
    // 行选中
    selectedRowChange (selectedRowKeys, selectedRows) {
      this.selectedRowKeys = selectedRowKeys;
      this.selectedRows = selectedRows;
    },
    // 表单搜索
    onSearch(value = {}) {
      const params = Object.assign({}, this.queryParams, value)
      delete params.searchFormLabel
      this.$refs.dataTable.searchParams = cloneDeep(params)
      this.$refs.dataTable.getData()
    },
    // 新增/修改框事件
    handleOk() {
      this.onSearch()
    },
    // 重置按钮操作
    resetQuery() {
      this.queryParams = {
        version: undefined,
        status: undefined,
        weekPlanVersion: undefined
      }
      this.$refs.dataTable.searchParams = this.queryParams
      this.$refs.refSearchForm.form.setFieldsValue(this.queryParams)
      this.$refs.versionSelectRef.handleSearch(''); // 版本
      this.$refs.weekPlanVersionRef.handleSearch(''); // 周版本计划
    }
  }
}
</script>

<style scoped lang="less">
.operation-btn{
  display: flex;
  justify-content: center;
  .ant-btn{
    padding: 0 4px;
  }
  .ant-btn-link:focus, .ant-btn-link:hover {
     border-color: transparent !important;
  }
}
</style>
